import axios from 'axios'

export default function fetchUser(id) {
  return (dispatch) =>
    dispatch({
      type: 'USER_FETCH',
      payload: axios(`/users/${id}`),
    })
}
